export default __webpack_public_path__ + "static/media/trash.349127a0.svg";